module.exports = __webpack_public_path__ + "static/media/contract4.94f8039a.png";